import React, { useState, useRef, useEffect } from "react";

const MoreVertIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-gray-400">
    <circle cx="12" cy="5" r="1.5" />
    <circle cx="12" cy="12" r="1.5" />
    <circle cx="12" cy="19" r="1.5" />
  </svg>
);

interface NodeMenuProps {
  onDelete: () => void;
  onReset: () => void;
}

export const NodeMenu: React.FC<NodeMenuProps> = ({ onDelete, onReset }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="p-1 rounded hover:bg-gray-100 transition-colors"
      >
        <MoreVertIcon />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1 bg-white border border-gray-200 rounded-xl shadow-lg z-50 min-w-[160px] overflow-hidden">
          <button
            onClick={() => { onDelete(); setOpen(false); }}
            className="w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
          >
            Delete Trigger
          </button>
          <button
            onClick={() => { onReset(); setOpen(false); }}
            className="w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
          >
            Reset Changes
          </button>
        </div>
      )}
    </div>
  );
};

export const EmptyTriggerDropZone = () => (
  <div className="border-2 border-dashed border-green-400 rounded-xl p-8 text-center min-w-[280px]">
    <p className="text-green-600 font-medium text-sm mb-1">
      Drag and Drop a Starting Trigger
    </p>
    <p className="text-[#7B7B7B] font-semibold text-xs">
      Drag a trigger to start configuring your bot journey
    </p>
  </div>
);